import React__default, { useContext } from 'react';
import { a as ModalStateContext } from './context-bc0cec4d.js';
import { styled } from '@teko/styled';
import { __rest } from 'tslib';
import { CloseOutlined } from '@teko/ds-icon';
import { p as pixelParse } from './utils-f1412689.js';

function useModal() {
    const context = useContext(ModalStateContext);
    if (!context) {
        throw new Error('useModal must be inside a ModalStateContext with a state value');
    }
    return context;
}

const ModalHeader = ({ children, className, }) => (React__default.createElement(Wrapper$2, { className: className },
    React__default.createElement(Title, null, children)));
const Wrapper$2 = styled.div `
  padding: 1rem;
  text-align: center;
`;
const Title = styled.h5 `
  margin-bottom: 0;
`;

const Wrapper$1 = styled.div `
  flex: 1 1 auto;
  padding: 0.5rem 2rem;
  position: relative;
`;
const ModalBody = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return React__default.createElement(Wrapper$1, Object.assign({}, props), children);
};

const Wrapper = styled.div `
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const ModalFooter = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return React__default.createElement(Wrapper, Object.assign({}, props), children);
};

const ModalCloseIcon = ({ onHide, closeIcon = React__default.createElement(CloseOutlined, { size: 32, color: "#000" }), className, }) => {
    return (React__default.createElement(CloseIconWrapper, { className: className, onClick: onHide }, closeIcon));
};
const CloseIconWrapper = styled.div(({ size }) => `
  z-index: 1060;
  position: absolute;
  left: 100%;
  transform: translateX(-100%);
  min-width: ${pixelParse(size) || '56px'};
  min-height: ${pixelParse(size) || '56px'};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`);

export { ModalHeader as M, ModalBody as a, ModalFooter as b, ModalCloseIcon as c, useModal as u };
